import { BILL_AUTOMATION_UPGRADE_FIELDS, SUBSCRIPTION_FORM_SUBMIT_URL, TIER_UPGRADE_FIELDS } from 'src/constants/billAutomation';

// HubSpot requires both names; '-' marks one the profile lacks rather than failing the whole request.
export const buildUpgradeSubmission = function (_ref, pageUri) {
  let firstName = _ref.firstName,
    lastName = _ref.lastName,
    email = _ref.email;
  let pageName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Bill automation upgrade (utility setup)';
  let upgradeFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : BILL_AUTOMATION_UPGRADE_FIELDS;
  return {
    fields: [...upgradeFields, {
      objectTypeId: '0-1',
      name: 'firstname',
      value: firstName || '-'
    }, {
      objectTypeId: '0-1',
      name: 'lastname',
      value: lastName || '-'
    }, {
      objectTypeId: '0-1',
      name: 'email',
      value: email
    }],
    context: {
      pageUri,
      pageName
    }
  };
};
const submit = async submission => {
  try {
    const resp = await fetch(SUBSCRIPTION_FORM_SUBMIT_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(submission)
    });
    return resp.ok;
  } catch (ex) {
    return false;
  }
};

/**
 * Files an "Upgrade to Bill Automation" request on the subscription form, the same one the Subscription tab links
 * to. HubSpot's public form endpoint: no token, posted straight from the browser like the embedded form itself.
 * Resolves true only when HubSpot accepted it, so the caller never claims a request it did not send.
 */
export const requestBillAutomationUpgrade = async function (profile) {
  let pageName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  let pageUri = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.location.href;
  if (!(profile !== null && profile !== void 0 && profile.email)) return false;
  return submit(buildUpgradeSubmission(profile, pageUri, pageName));
};

// The plan covers the whole portfolio, so the team must know whose: the name to read, the id to be sure.
const companyLabel = company => {
  const _ref2 = company || {},
    id = _ref2.id,
    name = _ref2.name;
  if (name && id) return "".concat(name, " (").concat(id, ")");
  return name || (id ? "company ".concat(id) : '');
};

/**
 * Files "Upgrade now" for a plan (LB-6187) on the same form, naming the plan, where it was asked and the company in the
 * page name, e.g. "Upgrade to Plus (setup editor) for Acme (89cb...)": the team reads the plan from there until the form
 * has an option for it. `company` is `{ id, name }`. Resolves true only when HubSpot accepted it.
 */
export const requestTierUpgrade = async function (profile, tier) {
  let where = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'utility setup';
  let company = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let pageUri = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.location.href;
  const fields = Object.prototype.hasOwnProperty.call(TIER_UPGRADE_FIELDS, tier) ? TIER_UPGRADE_FIELDS[tier] : null;
  if (!(profile !== null && profile !== void 0 && profile.email) || !fields) return false;
  const whose = companyLabel(company);
  const pageName = "Upgrade to ".concat(tier, " (").concat(where, ")").concat(whose ? " for ".concat(whose) : '');
  return submit(buildUpgradeSubmission(profile, pageUri, pageName, fields));
};